export enum PmsWritebackStatus {
  Pending = 0,
  Synced = 1,
  Error = 2
}